import { MessageDescriptor } from 'react-intl';
import { msgs } from './messages';

type QuestionDescriptor = {
  answer: MessageDescriptor;
  question: MessageDescriptor;
};

type GroupedQuestions = {
  [key: string]: QuestionDescriptor[];
};

export const extraTravelTopicQuestions: GroupedQuestions = {
  en: [
    {
      answer: msgs.answerTravelEn1,
      question: msgs.questionTravelEn1,
    },
    {
      answer: msgs.answerTravelEn2,
      question: msgs.questionTravelEn2,
    },
  ],

  es: [
    {
      answer: msgs.answerTravelEs1,
      question: msgs.questionTravelEs1,
    },
    {
      answer: msgs.answerTravelEs2,
      question: msgs.questionTravelEs2,
    },
  ],

  'es-mx': [
    {
      answer: msgs.answerTravelEsMx1,
      question: msgs.questionTravelEsMx1,
    },
    {
      answer: msgs.answerTravelEsMx2,
      question: msgs.questionTravelEsMx2,
    },
  ],

  fr: [
    {
      answer: msgs.answerTravelFr1,
      question: msgs.questionTravelFr1,
    },
    {
      answer: msgs.answerTravelFr2,
      question: msgs.questionTravelFr2,
    },
  ],

  it: [
    {
      answer: msgs.answerTravelIt1,
      question: msgs.questionTravelIt1,
    },
    {
      answer: msgs.answerTravelIt2,
      question: msgs.questionTravelIt2,
    },
  ],

  'jp-full': [
    {
      answer: msgs.answerTravelJpFull1,
      question: msgs.questionTravelJpFull1,
    },
    {
      answer: msgs.answerTravelJpFull2,
      question: msgs.questionTravelJpFull2,
    },
  ],
};

export const extraWorkTopicQuestions: GroupedQuestions = {
  de: [
    {
      answer: msgs.answerWorkDe,
      question: msgs.questionWorkDe,
    },
  ],

  en: [
    {
      answer: msgs.answerWorkEn,
      question: msgs.questionWorkEn,
    },
  ],

  'en-us': [
    {
      answer: msgs.answerWorkEnUs,
      question: msgs.questionWorkEnUs,
    },
  ],

  'es-mx': [
    {
      answer: msgs.answerWorkEsMx,
      question: msgs.questionWorkEsMx,
    },
  ],

  fr: [
    {
      answer: msgs.answerWorkFr,
      question: msgs.questionWorkFr,
    },
  ],
};

export const topicQuestions: QuestionDescriptor[] = [
  {
    answer: msgs.answer1,
    question: msgs.question1,
  },

  {
    answer: msgs.answer2,
    question: msgs.question2,
  },

  {
    answer: msgs.answer3,
    question: msgs.question3,
  },
];
